import React from 'react';
import PropTypes from 'prop-types';
import { useSelect } from 'downshift';
import Error from '../error/Error';
import * as classes from './Select.module.scss';
import classNames from 'classnames';

const Select = ({ value, onChange, options, label, error, variant }) => {
  const { isOpen, selectedItem, getToggleButtonProps, getLabelProps, getMenuProps, highlightedIndex, getItemProps } =
    useSelect({
      items: Object.keys(options),
      onSelectedItemChange: ({ selectedItem }) => onChange(selectedItem),
      initialSelectedItem: value
    });

  return (
    <div className={classes.select}>
      {label && (
        <label className={classes.selectLabel} {...getLabelProps()}>
          {label}
        </label>
      )}

      <button
        type="button"
        className={classNames(classes.selectButton, {
          [classes[`variant__${variant}`]]: variant
        })}
        {...getToggleButtonProps()}
      >
        {options[selectedItem] || null}
      </button>

      <ul
        className={classNames(classes.selectOptions, {
          [classes[`variant__${variant}`]]: variant
        })}
        hidden={!isOpen}
        {...getMenuProps()}
      >
        {isOpen &&
          Object.keys(options).map((item, index) => {
            const itemClassName = classNames(classes.selectOption, {
              [classes.selectOption_highlighted]: highlightedIndex === index,
              [classes.selectOption_selected]: selectedItem === item
            });

            return (
              <li key={`${item}${index}`} className={itemClassName} {...getItemProps({ item, index })}>
                {options[item]}
              </li>
            );
          })}
      </ul>

      {error && <Error>{error?.message}</Error>}
    </div>
  );
};
Select.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  options: PropTypes.object,
  label: PropTypes.node,
  error: PropTypes.object,
  variant: PropTypes.oneOf([null, 'overdraftCalculator'])
};

export default Select;
